import { render, staticRenderFns } from "./OrganizationEditTabAccount.vue?vue&type=template&id=678f87be&scoped=true"
import script from "./OrganizationEditTabAccount.vue?vue&type=script&lang=js"
export * from "./OrganizationEditTabAccount.vue?vue&type=script&lang=js"
import style0 from "./OrganizationEditTabAccount.vue?vue&type=style&index=0&id=678f87be&prod&lang=scss"
import style1 from "./OrganizationEditTabAccount.vue?vue&type=style&index=1&id=678f87be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678f87be",
  null
  
)

export default component.exports